<template>
  <div class="pets-container">
    <Carousel @pageChange="initialLoad = false" :per-page="1" :touch-drag="true" :minSwipeDistance="5"
              :scrollPerPage="true" :paginationEnabled="true"
    >
      <Slide
          v-for="pet in pets" :key="pet.id"
          id="pet.id" :class="{ 'VueCarousel-slide-active': initialLoad}">
        <div class="fl-sym-text-center fl-sym-margin-auto pet-slide">
          <img class="circle" src="@/assets/dog-photo.png" width="30"/>
            <div @click="()=>toEditPage(pet.id)" class="fl-sym-text-black fl-sym-text-2xl fl-sym-font-bold fl-sym-letter-space-1 fl-sym-cursor-pointer">
              {{ pet.name }}
              <img  src="@/assets/pen-icon.svg" width="16" class="pencil"/>
            </div>
            <div class="fl-sym-text-light-grey fl-sym-font-family-light fl-sym-text-sm pet-details">
              {{ getAge(pet.date_of_birth) }} {{ pet.species }}
            </div>
        </div>
      </Slide>
    </Carousel>


  </div>
</template>

<script>
import Vue from 'vue'
import VueCarousel from 'vue-carousel';
import {Carousel, Slide} from 'vue-carousel';
import {mapState} from "vuex";
import getAgeFromDOB from "@/utils/getAgeFromDOB.js"

Vue.use(VueCarousel);
export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      initialLoad: false,
    }
  },
  methods: {
    getAge(dob) {
      return getAgeFromDOB(dob)
    },
    toEditPage(id) {
      console.info("PET ID:", id)
      this.$router.push({name: process.env.VUE_APP_PET_PROFILE_EDIT, params: {slug: id}})
    },
  },
  computed: {
    ...mapState({
      pets: (state) => state.pet.pets,
    }),
  },
}
</script>

<style>
.pets-container {
  overflow: hidden;
  display: inline-block;
  position: relative;
  user-select: none;
}

.pet-details {
  font-weight: 100;
  letter-spacing: 0.1px;
}

.pencil {
  display: inline-block;
  margin-left: 7px;
  margin-bottom: 7px;
}

.circle {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  filter: opacity(0.4);
}

.fl-sym-margin-auto {
  margin: auto;
}

.VueCarousel-slide-active .pet-slide .circle {
  filter: opacity(1);
  z-index: 1000;
  position: relative;
  top: -10px;
  width: 8.5rem;
  height: 8.5rem;
  transition: all linear 0.5s;
}

.pets-container {
  width: 10rem;
  float: right;
}

.pet-slide {
  width: 9rem;
  padding-top: 2rem;
  margin-right: -4rem;
}

.VueCarousel-slide {
  backface-visibility: visible !important;
}

.VueCarousel-inner {
  width: 50%;
  height: 210px !important;
}

.pet-slide a {
  display: none;
}

.VueCarousel-slide-active .pet-slide a {
  display: block;
}

.VueCarousel {
  height: 280px;
}

</style>
